import { OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import english from './i18n/en.json';
import spanish from './i18n/es.json';
import portuguese from './i18n/pt.json';
var VideoInfoModalComponent = /** @class */ (function () {
    function VideoInfoModalComponent(data, domSanitizer, fuseTranslationLoaderService) {
        this.data = data;
        this.domSanitizer = domSanitizer;
        this.fuseTranslationLoaderService = fuseTranslationLoaderService;
        this.fuseTranslationLoaderService.loadJsonTranslations({ english: english, portuguese: portuguese, spanish: spanish });
    }
    VideoInfoModalComponent.prototype.ngOnInit = function () {
        this.videoUrl = this.domSanitizer.bypassSecurityTrustResourceUrl("https://www.youtube.com/embed/" + this.data.videoId + "?modestbranding=1&rel=0");
    };
    return VideoInfoModalComponent;
}());
export { VideoInfoModalComponent };
